import type { SagaIterator } from 'redux-saga'
import { all, call, takeEvery, takeLatest } from 'redux-saga/effects'

import { AIExternalActions } from '../actions'
import { isAiChatV2Enabled } from '../v2/config'
import { sendMessage } from './sendMessage'
import { startChat } from './startChat'
import { stopMessage } from './stopMessage'
import { sendMessageV2, startChatV2, stopMessageV2 } from './v2'

// The OCT-4799 feature flag is resolved per action (not at module load) so
// it can be toggled at runtime; with the flag off the v1 sagas run untouched.

function* startChatWorker(
  action: ReturnType<typeof AIExternalActions.startChat>
): SagaIterator {
  if (isAiChatV2Enabled()) {
    yield call(startChatV2, action)
  } else {
    yield call(startChat, action)
  }
}

function* sendMessageWorker(
  action: ReturnType<typeof AIExternalActions.sendMessage>
): SagaIterator {
  if (isAiChatV2Enabled()) {
    yield call(sendMessageV2, action)
  } else {
    yield call(sendMessage, action)
  }
}

function* stopMessageWorker(): SagaIterator {
  if (isAiChatV2Enabled()) {
    yield call(stopMessageV2)
  } else {
    yield call(stopMessage)
  }
}

export function* aiSaga() {
  yield all([
    takeEvery(AIExternalActions.startChat, startChatWorker),
    takeLatest(AIExternalActions.sendMessage, sendMessageWorker),
    takeEvery(AIExternalActions.stopMessage, stopMessageWorker),
  ])
}
